module.exports = __webpack_public_path__ + "img/cate-icon-7.11a0ef6f.png";